import React, { useCallback, useContext, useRef } from 'react'
import { FormContext } from '../context/FormContext'
import { getNextQuestion, getPreviousQuestion, saveAnswer } from '../api/prediagnosticoApi'
import QuestionField from '../components/fields/QuestionField'
import toast from 'react-hot-toast'

const submit = async (value, order, context, div) => {
  const { questionData, setQuestionData, setLoading } = context
  const question = questionData.question
  const questionId = question.pregunta_grupo
  const indice = question.indice
  const type = question.tipo_pregunta
  const isFile = type === 'ARCHIVO' && value

  const sequence = []

  if (isFile) {
    setLoading(true)
    const response = await saveAnswer(questionId, order, value, indice, isFile)
    sequence.push(new Promise(resolve => resolve(response)))
    setLoading(false)
  } else {
    sequence.push(saveAnswer(questionId, order, value, indice, isFile))
  }

  let isFinish = false
  let animFinish = false

  const animationPromise = () => new Promise(resolve => {
    div.addEventListener('animationend', () => {
      animFinish = true
      resolve()
    }, { once: true })

    setTimeout(() => {
      if (!isFinish) setLoading(true)
    }, 1500)
  })

  sequence.push(animationPromise())

  div.classList.add('animate__fadeOutDown')

  try {
    const [response] = await Promise.all(sequence)
    setQuestionData(response, 'animate__fadeInDown')
  } catch (error) {
    toast.error('Ocurrió un error al guardar la respuesta, comprueba tu conexión a internet y vuelve a intentarlo')
    if (!animFinish) await animationPromise()
    question.respuesta_texto = value
    question.respuesta_seleccion = value
    question.respuestas_multiple = value
    setQuestionData(questionData, 'animate__fadeInUp')
  } finally {
    isFinish = true
    setLoading(false)
  }
}

const next = async (context, div) => {
  const { questionData, setQuestionData, setLoading } = context
  const question = questionData.question
  const indice = question.indice

  let isFinish = false

  const animationPromise = new Promise(resolve => {
    div.addEventListener('animationend', resolve, { once: true })

    setTimeout(() => {
      if (!isFinish) setLoading(true)
    }, 1500)
  })

  div.classList.add('animate__fadeOutDown')

  const [response] = await Promise.all([
    getNextQuestion(indice),
    animationPromise
  ])

  isFinish = true
  setLoading(false)

  div.classList.remove('animate__fadeOutDown')
  setQuestionData(response, 'animate__fadeInDown')
}

const back = async (context, div) => {
  const { questionData, setQuestionData, setLoading } = context
  const question = questionData.question
  const indice = question.indice

  div.classList.add('animate__fadeOutUp')

  let isFinish = false

  setTimeout(() => {
    if (!isFinish) setLoading(true)
  }, 1500)

  const response = await getPreviousQuestion(indice)
  isFinish = true

  setLoading(false)

  div.classList.remove('animate__fadeOutUp')

  setQuestionData(response, 'animate__fadeInUp')
}

const spanStyle = {
  fontSize: '14px',
  color: 'rgb(26, 145, 162)',
  fill: 'rgb(26, 145, 162)'
}

const Question = () => {
  const divRef = useRef(null)
  const formContext = useContext(FormContext)
  const { questionData } = formContext

  const question = questionData.question

  const groupName = question.nombre_grupo
  const pregunta = question.pregunta
  const partesPregunta = pregunta.split('-')
  const tienePartes = partesPregunta.length > 1

  const ordenPregunta = question.indice
  const required = question.es_obligatoria

  const backCallback = useCallback(() => back(formContext, divRef.current), [formContext, divRef])

  return (
    <div ref={divRef} className={'animate__animated animate__faster w-full justify-start flex flex-col ' + questionData.animation}>
      <div className='flex'>
        {
          ordenPregunta > 1 && (
            <svg height='10' width='11' className='rotate-180 cursor-pointer ' onClick={backCallback}>
              <path d='M7.586 5L4.293 1.707 5.707.293 10.414 5 5.707 9.707 4.293 8.293z' /><path d='M8 4v2H0V4z' />
            </svg>
          )
        }

        <h1 className='font-semibold text-gray-900 w-full text-right mb-6 xl:text-base md:text-sm text-xs text-opacity-80'>{groupName}</h1>
      </div>
      <div className='text-gray-600  mb-6 xl:text-xl md:text-lg sm:text-base flex items-start'>
        <span className='flex items-center mr-2' style={spanStyle}>
          <span className='mr-2'>{ordenPregunta}</span>
          <svg height='10' width='11'><path d='M7.586 5L4.293 1.707 5.707.293 10.414 5 5.707 9.707 4.293 8.293z' /><path d='M8 4v2H0V4z' /></svg>
        </span>
        <div className='w-full'>
          {partesPregunta.map((part, index) => {
            const partesNegrita = part.split('**')
            const className = index === 0 ? 'mb-3' : 'text-gray-600 text-sm mb-1'

            return (

              <h6 key={index} className={(tienePartes ? className : '')}>
                {
                  partesNegrita.map((part, index) => {
                    return index % 2 === 0 ? part : <strong key={index}>{part}</strong>
                  })
                }
              </h6>
            )
          })}
        </div>
        {required && <span className='text-red-500'>*</span>}
      </div>
      <div className='md:pl-10'>
        <QuestionField div={divRef} submit={submit} next={next} formContext={formContext} />
      </div>
    </div>
  )
}

export default Question
